// La columna del PASO 2 de Automática en desktop: lo elegido, la instrucción y el pie con
// los ajustes y el Generar — ADR-2026-10-15-automatico-en-dos-pasos-en-escritorio.
//
// Es la misma anatomía que el paso 2 del modo Modelo (`PanelCompacto`) sin lo que este
// modo no tiene: ni Modelo, ni Pose, ni Fondo, porque la escena la decide la IA
// (ADR-2026-08-28-automatico-sin-fondo). Se arma con las MISMAS piezas —`CardProductos`,
// `InstruccionConInterruptor` y `PieConfiguracionModo`— para que el paso se vea igual que el de
// Modelo y no se despegue en el primer retoque.
//
// Es el layout en dos piezas de siempre: lo que scrollea arriba y el pie fijo abajo.
// Quien lo monta le da el alto (`flex flex-col`, no `overflow-y-auto`) o el pie se va de
// la vista.

import React from 'react';
import { CardProductos } from '../modelo/PanelCompacto';
import { type CalidadImagen } from './AjustesRapidosProducto';
import { InstruccionConInterruptor } from './InstruccionConInterruptor';
import { PieConfiguracionModo } from './PieConfiguracionModo';
import type { MockProductV2 } from '../mockData';

export interface PanelAutomaticoCompactoProps {
  products: MockProductV2[];
  /** Abre (o cierra) el panel lateral con la grilla de productos. */
  onAbrirProductos: () => void;
  /** Archivos soltados sobre la card de productos. */
  onSubirArchivos: (files: FileList | File[]) => void;
  instruccion: string;
  onInstruccionChange: (v: string) => void;
  calidad: CalidadImagen;
  onCalidadChange: (v: CalidadImagen) => void;
  formatoLabel: string;
  /** Abre (o cierra) el panel lateral de formatos. */
  onOpenFormato: () => void;
  cantidad: number;
  cantidadMax: number;
  onCantidadChange: (v: number) => void;
  creditCost: number | null;
  onGenerate: () => void;
  /** Con algo sin elegir el CTA se apaga y esto dice qué falta. */
  falta?: string | null;
  /** Sin nada pendiente: qué va a salir ("3 imágenes con los 2 productos juntos…"). */
  nota?: React.ReactNode;
}

export const PanelAutomaticoCompacto: React.FC<PanelAutomaticoCompactoProps> = ({
  products,
  onAbrirProductos,
  onSubirArchivos,
  instruccion,
  onInstruccionChange,
  calidad,
  onCalidadChange,
  formatoLabel,
  onOpenFormato,
  cantidad,
  cantidadMax,
  onCantidadChange,
  creditCost,
  onGenerate,
  falta,
  nota,
}) => (
  <div className="h-full min-h-0 flex flex-col">
    <div className="flex-1 min-h-0 overflow-y-auto flex flex-col gap-4 pb-4">
      {/* "Añadir producto" y el "+", como en mobile
          (ADR-2026-09-23-automatico-la-card-dice-anadir-producto): acá no se arma un
          outfit, se le suman productos a la escena. */}
      <CardProductos
        products={products}
        onAbrirProductos={onAbrirProductos}
        onSubirArchivos={onSubirArchivos}
        copyElegido="Añadir producto"
        iconoElegido="agregar"
      />
      {/* Detrás de un interruptor
          (ADR-2026-10-15-la-instruccion-de-automatico-se-despliega-con-un-interruptor). */}
      <InstruccionConInterruptor valor={instruccion} onChange={onInstruccionChange} />
    </div>
    <PieConfiguracionModo
      calidad={calidad}
      onCalidadChange={onCalidadChange}
      formatoLabel={formatoLabel}
      onOpenFormato={onOpenFormato}
      formatoAbrePanelLateral
      contador={{ valor: cantidad, max: cantidadMax, onChange: onCantidadChange }}
      imagenesDeLaTanda={cantidad}
      creditCost={creditCost}
      onGenerate={onGenerate}
      falta={falta}
      nota={nota}
    />
  </div>
);
